import type { NotificationDashboardProps } from '@/utils/hooks/context/toast/types';

// Components
import DashboardInvitationAccepted from '@/components/composite/Notifications/Dashboard/DashboardInvitationAccepted';
import DashboardInvitationReceived from '@/components/composite/Notifications/Dashboard/DashboardInvitationReceived';

const NotificationsDashboard = ({ notification }: NotificationDashboardProps) => {
    const type = notification.type;
    switch (type) {
        case 'invitation_accepted':
            return <DashboardInvitationAccepted notification={notification} />;
        case 'invitation_received':
            return <DashboardInvitationReceived notification={notification} />;
        default:
            return null;
    }
};

export default NotificationsDashboard;
